var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 10C11.8513 10 14.0898 7.76142 14.0898 5C14.0898 2.23858 11.8513 0 9.08984 0C6.32842 0 4.08984 2.23858 4.08984 5C4.08984 7.76142 6.32842 10 9.08984 10Z",
    fill: "#45436B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09 12.5C4.08 12.5 0 15.86 0 20C0 20.28 0.22 20.5 0.5 20.5H17.68C17.96 20.5 18.18 20.28 18.18 20C18.18 15.86 14.1 12.5 9.09 12.5Z",
    fill: "#45436B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5cd2ddc085e69610ef40759fbf60b385.svg";
export { ForwardRef as ReactComponent };